import { useEffect, useState } from "react";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import SingleStore from "./SingleStore";
import axiosInstance from "../../config/axiosInstance";

function Stores({ appSettings }) {
    const [stores, setStores] = useState([]);

    const { ClientId: clientID, AppBaseURL1 } = appSettings;

    useEffect(() => {
        loadStores();
    }, []);

    async function loadStores() {
        const payLoad = {
            DATA: {
                client_id: clientID,
            },
        };
    
        try {
            // Sending the request with Axios
            const { data } = await axiosInstance.post(`${AppBaseURL1}Loy_GetLocationDetails`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            if (data.STATUS) {
                setStores(data.DATA);
            }
        } catch (error) {
            console.error("Error loading stores:", error);
        }
    }
    

    return (
        <AnimatedPage>
            <div className="min-vh-100 transition-0-5-bounce bg-wafaa-white-3 pb-4">
                <div className="position-sticky z-2 top-0">
                    <PageTitle name="STORES" />
                </div>

                <div className="my-4 w-90 mx-auto rounded-3 shadow-lg bg-wafaa-white-2 ">
                    {stores.map((store, index) => (
                        <>
                            <SingleStore store={store} key={index} />
                            {stores.length - 1 !== index && <div style={{ borderBottom: "1px dashed gray" }}></div>}
                        </>
                    ))}
                </div>
            </div>
        </AnimatedPage>
    );
}

export default Stores;
